export const SET_MISSING_INDICATORS = 'SET_MISSING_INDICATORS';
export const UNSET_MISSING_INDICATORS = 'UNSET_MISSING_INDICATORS';



// WEBPACK FOOTER //
// ./src/vuex/modules/missing/types/mutations.js